import { Menu01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { AppBar, Button, Toolbar } from "@mui/material";
import Logo from '@/assets/logos/bitelink-logo-light.svg';
import { Dispatch, SetStateAction } from "react";
interface Props {
  isSidebarExpanded: boolean;
  setIsSidebarExpanded: Dispatch<SetStateAction<boolean>>;
}

const Mobilenavigation = ({ setIsSidebarExpanded }: Props) => {
    return (
        <AppBar
            elevation={0}
            position="static"
            color="transparent"
            sx={{
                zIndex: 1500,
                '&.MuiPaper-root': {
                    borderRadius: 0,
                },
                marginTop: 2,
            }}
        >
            <Toolbar sx={{
                justifyContent: 'space-between',
                '&.MuiToolbar-root': {
                    paddingLeft: 2,
                    paddingRight: 2,
                }
            }}>
                <img src={Logo} alt="BiteLink" style={{ height: '43px' }} />
                <Button
                    onClick={() => setIsSidebarExpanded(true)}
                >
                    <HugeiconsIcon icon={Menu01Icon} />
                </Button>
            </Toolbar>
        </AppBar>
    )
}

export default Mobilenavigation;
